module.exports = __webpack_public_path__ + "static/img/hr-icon-3.7ee69c15.svg";